import RedesignDescriptor from './inbox-redesign';
import RefiveDescriptor from './inbox-refive';
import CanteenDescriptor from './inbox-canteen';
import CompanyKitchenDescriptor from './inbox-companykitchen';
import AramarkDescriptor from './inbox-aramark';
import Settings from 'src/Settings';
import Deal from 'src/models/Moblico/Deal';
import {BuildTypeEnum} from 'src/constants/BuildTypeEnum';
BuildTypeEnum;

const typeDescriber = {
  [BuildTypeEnum.aramark]: AramarkDescriptor,
  [BuildTypeEnum.canteen]: CanteenDescriptor,
  [BuildTypeEnum.default]: RedesignDescriptor,
  [BuildTypeEnum.companykitchen]: CompanyKitchenDescriptor,
  [BuildTypeEnum.refive]: RefiveDescriptor,
};

export interface DealDescriberData {
  styles: {[index: string]: {[index: string]: number | string}};
  deal: Deal;
}

export function getDescriber() {
  return typeDescriber[Settings.buildType as keyof typeof typeDescriber];
}
